module.exports = __webpack_public_path__ + "img/done.d004bfc9.svg";